<template>
  <div class="exhibitedWork">
    <span>Cat. n° {{exhibitedWork.number}} :</span>

    <span v-if="exhibitedWork.title" class="title">{{exhibitedWork.title}}</span>
    <span v-if="exhibitedWork.subtitle" class="subtitle">{{exhibitedWork.subtitle}}</span>
    <span v-if="!exhibitedWork.title">[titre non indiqué]</span>
    <span v-if="exhibitedWork.translation_title">[{{exhibitedWork.translation_title}}]</span>
    <br>
    <span v-if="exhibitedWork.medium">Medium : {{exhibitedWork.medium}}. </span>
    <span v-if="exhibitedWork.category">Catégorie : {{exhibitedWork.category}}. </span>
    <span v-if="exhibitedWork.price">Prix : {{exhibitedWork.price}}. </span>

    <span v-if="exhibitedWork.year_c1">{{exhibitedWork.year_c1}}, </span>
    <span v-if="exhibitedWork.city_c">{{exhibitedWork.city_c}}</span>
    <span v-if="exhibitedWork.year_c1 || exhibitedWork.city_c">.</span>

    <span v-if="exhibitedWork.size">Dim : {{exhibitedWork.size}}.</span>

    <span v-if="exhibitedWork.is_reproduced_in_catalog == 't'">
      Oeuvre reproduite au catalogue.
    </span>

    <span v-if="exhibitedWork.owner">
      Propriétaire: {{exhibitedWork.owner}}<span v-if="exhibitedWork.city_o">, {{exhibitedWork.city_o}}</span>.
    </span>

    <span v-if="exhibitedWork.notes">Notes: {{exhibitedWork.notes}}.</span>
  </div>
</template>

<script>

export default {
  name: 'exhibitedWorkDialog',
  props: ['exhibitedWork']
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/ExhibitedWork/ExhibitedWorkDialog.vue